import React, { useEffect, useMemo, useState, useContext } from 'react'

import './gameContent.scss'
import { navigate } from 'gatsby'

import { Context } from '../../../context/app-context'

import SceneOneOne from '../../../assets/scenarios/scene1_1.inline.svg'
import SceneOneTwo from '../../../assets/scenarios/scene1_2.inline.svg'
import SceneOneThree from '../../../assets/scenarios/scene1_3.inline.svg'

import SceneTwowOne from '../../../assets/scenarios/scene2_1.inline.svg'
import SceneTwoTwo from '../../../assets/scenarios/scene2_2.inline.svg'
import SceneTwoThree from '../../../assets/scenarios/scene2_3.inline.svg'
import { gameId } from '../../../constants/activity-constants'
import GameServices from '../../../services/game-service'
import userSessionStorage from '../../../utils/userSessionStorage'

import SceneThreeOne from '../../../assets/scenarios/scene3_1.inline.svg'
import SceneThreeTwo from '../../../assets/scenarios/scene3_2.inline.svg'
import SceneThreeThree from '../../../assets/scenarios/scene3_3.inline.svg'

const GameContent = (
  {
    mobile,
    setModalActive,
  },
) => {
  const { dispatch } = useContext(Context)
  const [session] = useState(new userSessionStorage())


  const handleSuccesModal = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: null,
      },
    })
    setClearTime(false)
  }

  useEffect(() => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `login`,
          props: {
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
            handleStartGame: () => {
              handleSuccesModal()
            },
          },
        },
      },
    })

  }, [])


  let initialSeconds = 40

  const [points, setPoints] = useState(0)

  const [uteroFind, setUteroFind] = useState(false)
  const [flujoFind, setFlujoFind] = useState(false)
  const [sangreFind, setSangreFind] = useState(false)

  // timer
  const [seconds, setSeconds] = useState(initialSeconds)
  const [clearTime, setClearTime] = useState(true)


  const [actualScene, setActualScene] = useState(false)

  useEffect(() => {
    if (uteroFind && sangreFind && flujoFind) {
      setClearTime(true)
      endGame()
    }

  }, [uteroFind, flujoFind, sangreFind])




  const endGame = () => {
    let pointsWin = 0
    if (uteroFind) pointsWin = pointsWin + 5
    if (flujoFind) pointsWin = pointsWin + 5
    if (sangreFind) pointsWin = pointsWin + 5
    pointsWin = pointsWin + seconds

    handleTokenGameRedemption(pointsWin)

    if(!uteroFind && !flujoFind && !sangreFind){
      // modal 0 puntos
      dispatch({
        type: 'set',
        payload: {
          modalActive: {
            type: `endFailure`,
            props: {
              close: () => {
                navigate('/')
                dispatch({
                  type: 'set',
                  payload: {
                    modalActive: null,
                  },
                })
              },
              points: pointsWin,
              blur: true
            },
          },
        },
      })


    }else if(seconds === 0){
      // modal fin juego por tiempo

      dispatch({
        type: 'set',
        payload: {
          modalActive: {
            type: `endTime`,
            props: {
              close: () => {
                navigate('/')
                dispatch({
                  type: 'set',
                  payload: {
                    modalActive: null,
                  },
                })
              },
              points: pointsWin,
              blur: true

            },
          },
        },
      })


    }else{

      dispatch({
        type: 'set',
        payload: {
          modalActive: {
            type: `endSuccess`,
            props: {
              close: () => {
                navigate('/')
                dispatch({
                  type: 'set',
                  payload: {
                    modalActive: null,
                  },
                })
              },
              points: pointsWin,
              blur: true

            },
          },
        },
      })
      // modal fin juego exito
    }

  }

  //redimir participacion
  const handleTokenGameRedemption = async (points) => {
    let tokenParticipationSession = sessionStorage.getItem('tokenParticipation')


    let payload = {
      point: points,
      tokenGame: tokenParticipationSession,
      gameId: gameId,
    }

    let tokenId = session.getToken().idToken

    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    try {
      const participationSaveResponse = await GameServices.postGameParticipationSave(
        payload,
        config,
      )
    } catch (error) {
      console.log(error)
    }
  }

  const scenaries = [
    <><SceneOneOne className='scenary' /></>,
    <><SceneOneTwo className='scenary' /></>,
    <><SceneOneThree className='scenary' /></>,
    <><SceneTwowOne className='scenary' /></>,
    <><SceneTwoTwo className='scenary' /></>,
    <><SceneTwoThree className='scenary' /></>,
    <><SceneThreeOne className='scenary' /></>,
    <><SceneThreeTwo className='scenary' /></>,
    <><SceneThreeThree className='scenary' /></>,
  ]


  useEffect(() => {
    let scene = Math.floor((Math.random() * (9 - 1 + 1)) + 1)
    setActualScene(scenaries[scene - 1])
  }, [])
  // load events click for find person

  useEffect(() => {
    let utero = document.getElementsByClassName('utero')
    let flujo = document.getElementsByClassName('flujo')
    let sangre = document.getElementsByClassName('sangre')

    const setFindPerson = (person) => {
      // utero.classList.add('storke-color')
      switch (person) {
        case 'utero':
          setUteroFind(true)
          for (let i = 0; i < utero.length; i++) {
            utero[i].classList.add('storke-color')
          }
          break
        case 'flujo':
          setFlujoFind(true)
          for (let i = 0; i < flujo.length; i++) {
            flujo[i].classList.add('storke-color')
          }
          break
        case 'sangre':
          setSangreFind(true)
          for (let i = 0; i < sangre.length; i++) {
            sangre[i].classList.add('storke-color')
          }
          break
      }
    }

    for (let i = 0; i < utero.length; i++) {
      utero[i].addEventListener('click', () => setFindPerson('utero'), false)
    }
    for (let i = 0; i < flujo.length; i++) {
      flujo[i].addEventListener('click', () => setFindPerson('flujo'), false)
    }
    for (let i = 0; i < sangre.length; i++) {
      sangre[i].addEventListener('click', () => setFindPerson('sangre'), false)
    }


  }, [actualScene])


// timer logic

  useEffect(() => {
    let timer

    if (!clearTime) {
      timer = setTimeout(() => {
        setSeconds(seconds - 1)
      }, 1000)

      if (seconds < 1) {
        clearTimeout(timer)
        endGame()
      }
    } else {
      clearTimeout(timer)
    }
  }, [seconds, clearTime])

  return (
    <div className='f-busquedadMisteriosa__game'>
      <div className='f-busquedadMisteriosa__game__wrapper'>
        <div className='f-busquedadMisteriosa__game__image'>
          {actualScene && (
            <div className='f-busquedadMisteriosa__game__timer'>
              <h3>TIEMPO</h3>
              <p> {seconds} seg</p>
            </div>
          )}

          {actualScene ? (
            actualScene
          ) : (
            <div className='lds-ring'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default GameContent


